export const ham = (): void => {
  const ham = document.querySelector('.c-ham__container') as HTMLElement;
  const header = document.querySelector('.l-header') as HTMLElement;
  const hamLinks = document.querySelectorAll('.l-header a');
  const overlay = document.querySelector('.l-header-nav__overlay') as HTMLElement;
  ham.addEventListener('click', () => {
    header.classList.toggle('is-ham-open');
  });
  // hamLinks.forEach((link) => {
  //   link.addEventListener('click', () => {
  //     header.classList.remove('is-ham-open');
  //   });
  // });
  overlay.addEventListener('click', () => {
    header.classList.remove('is-ham-open');
  });
};
